"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var classNames = require("classnames");
var lodash_1 = require("lodash");
var select_facet_1 = require("./select_facet");
var text_input_facet_1 = require("./text_input_facet");
var nested_select_facet_1 = require("./nested_select_facet");
var range_facet_1 = require("./range_facet");
var region_select_filter_1 = require("./region_select_filter");
var sidebar_toggle_1 = require("./sidebar_toggle");
var search_filters_1 = require("./search_filters");
var graphql_tag_1 = require("graphql-tag");
exports.nestedFilterFragment = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  fragment NestedFilter on reverb_search_Filter {\n    name\n    aggregationName\n    widgetType\n    options {\n      count {\n        value\n      }\n      name\n      selected\n      paramName\n      setValues\n      unsetValues\n      all\n      optionValue\n      subFilter {\n        widgetType\n        options {\n          count {\n            value\n          }\n          name\n          selected\n          paramName\n          setValues\n          unsetValues\n          all\n          optionValue\n          subFilter {\n            widgetType\n            options {\n              count {\n                value\n              }\n              name\n              selected\n              paramName\n              setValues\n              unsetValues\n              all\n              optionValue\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  fragment NestedFilter on reverb_search_Filter {\n    name\n    aggregationName\n    widgetType\n    options {\n      count {\n        value\n      }\n      name\n      selected\n      paramName\n      setValues\n      unsetValues\n      all\n      optionValue\n      subFilter {\n        widgetType\n        options {\n          count {\n            value\n          }\n          name\n          selected\n          paramName\n          setValues\n          unsetValues\n          all\n          optionValue\n          subFilter {\n            widgetType\n            options {\n              count {\n                value\n              }\n              name\n              selected\n              paramName\n              setValues\n              unsetValues\n              all\n              optionValue\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
exports.flatFilterFragment = graphql_tag_1.default(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  fragment FlatFilter on reverb_search_Filter {\n    name\n    aggregationName\n    widgetType\n    options {\n      count {\n        value\n      }\n      name\n      selected\n      paramName\n      setValues\n      unsetValues\n      all\n      optionValue\n    }\n  }\n"], ["\n  fragment FlatFilter on reverb_search_Filter {\n    name\n    aggregationName\n    widgetType\n    options {\n      count {\n        value\n      }\n      name\n      selected\n      paramName\n      setValues\n      unsetValues\n      all\n      optionValue\n    }\n  }\n"])));
var FACET_MAPPING = (_a = {},
    _a[search_filters_1.WidgetType.TEXT] = text_input_facet_1.default,
    _a[search_filters_1.WidgetType.NESTED_SELECT] = nested_select_facet_1.default,
    _a[search_filters_1.WidgetType.CHECKBOX] = select_facet_1.default,
    _a[search_filters_1.WidgetType.RADIO] = select_facet_1.default,
    _a[search_filters_1.WidgetType.RANGE] = range_facet_1.default,
    _a[search_filters_1.WidgetType.REGION_SELECT] = region_select_filter_1.default,
    _a[search_filters_1.WidgetType.NONE] = null,
    _a[search_filters_1.WidgetType.SORT] = null,
    _a);
var RQLFacets = /** @class */ (function (_super) {
    tslib_1.__extends(RQLFacets, _super);
    function RQLFacets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasLoaded: false,
        };
        return _this;
    }
    RQLFacets.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (prevState.hasLoaded)
            return;
        this.setState({
            hasLoaded: true,
        });
    };
    RQLFacets.prototype.hasValidFacets = function () {
        return this.filterValid(this.props.filters).length;
    };
    RQLFacets.prototype.filterValid = function (facets) {
        if (!facets)
            return null;
        return facets.filter(function (f) { return f.options.length; });
    };
    RQLFacets.prototype.getCategoryFacet = function () {
        var firstFacet = this.props.filters && this.props.filters[0];
        if (firstFacet && firstFacet.widgetType === search_filters_1.WidgetType.NESTED_SELECT) {
            return firstFacet;
        }
    };
    RQLFacets.prototype.renderFacet = function (facet) {
        var FacetComponent = FACET_MAPPING[facet.widgetType];
        if (facet.options.length === 0 || !FacetComponent)
            return null;
        return (React.createElement(FacetComponent, { filter: facet, key: lodash_1.kebabCase(facet.name) }));
    };
    RQLFacets.prototype.renderCategoryFacet = function () {
        var categoryFacet = this.getCategoryFacet();
        if (!categoryFacet || !categoryFacet.options.length)
            return null;
        return (React.createElement("div", { className: "facet-container" }, this.renderFacet(categoryFacet)));
    };
    RQLFacets.prototype.renderRemainingFacets = function () {
        var facets = this.getCategoryFacet() ? this.props.filters.slice(1) : this.props.filters;
        var validFacets = this.filterValid(facets);
        if (!validFacets) {
            return null;
        }
        return (React.createElement("div", { className: "facet-container" }, validFacets.map(this.renderFacet)));
    };
    RQLFacets.prototype.renderPlaceholder = function () {
        return (React.createElement("div", { className: "facet-sidebar facet-sidebar--placeholder" },
            React.createElement("div", { className: "facet-container" }),
            React.createElement("div", { className: "facet-container" })));
    };
    RQLFacets.prototype.render = function () {
        if (this.props.loading && !this.state.hasLoaded) {
            return this.renderPlaceholder();
        }
        if (!this.hasValidFacets())
            return null;
        var classes = classNames('facet-sidebar', { 'facet-sidebar--loading': this.props.loading });
        return (React.createElement("div", { className: classes },
            React.createElement("header", { className: "facet-sidebar__header" },
                React.createElement(sidebar_toggle_1.default, { close: true }),
                React.createElement("h4", { className: "weight-bold size-90" }, I18n.t('commons.filters.filterResults'))),
            React.createElement("div", { className: "facet-sidebar__contents" },
                this.renderCategoryFacet(),
                this.renderRemainingFacets(),
                this.props.sidebarContent)));
    };
    return RQLFacets;
}(React.Component));
exports.default = RQLFacets;
var templateObject_1, templateObject_2;
//# sourceMappingURL=rql_facets.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/rql_facets.js
// module id = kn1M
// module chunks = 0 1 2 3 9 10 14 20